/* eslint-disable react/jsx-props-no-spreading */
import React, {
    Children,
    cloneElement,
    createContext,
    forwardRef,
    useContext,
    useEffect,
    useRef,
    ReactNodeArray,
    RefObject,
} from 'react';
import {
    ListChildComponentProps,
    VariableSizeList,
} from 'react-window';
import wrap from 'wraptile';

const LISTBOX_PADDING = 4;
const ITEM_SIZE = 28;

const OuterElementContext = createContext({});

export const getChildSize = () => ITEM_SIZE;
export const sum = (a: number, b: number) => a + b;
export const getHeight = (itemData: ReactNodeArray) => itemData.map(getChildSize).reduce(sum, 0);
export const itemSize = () => getChildSize();

const ListboxComponent = forwardRef<HTMLDivElement>((props, ref) => {
    const {children, ...other} = props;
    const itemData = Children.toArray(children);
    const itemCount = itemData.length;
    
    const gridRef = useResetCache(itemCount);
    
    const height = getHeight(itemData) + 2 * LISTBOX_PADDING;
    return (
        <div ref={ref}>
            <OuterElementContext.Provider value={other}>
                <VariableSizeList
                    width="100%"
                    innerElementType="ul"
                    ref={gridRef}
                    itemData={itemData}
                    height={height}
                    outerElementType={OuterElementType}
                    itemSize={itemSize}
                    overscanCount={5}
                    itemCount={itemCount}
                >
                    {renderAutocompleteRow}
                </VariableSizeList>
            </OuterElementContext.Provider>
        </div>
    );
});

export default ListboxComponent;

export const OuterElementType = forwardRef<HTMLDivElement>((props, ref) => {
    const outerProps = useContext(OuterElementContext);
    return (
        <div
            ref={ref}
            {...props}
            {...outerProps}
        />
    );
});

export function renderAutocompleteRow(props: ListChildComponentProps) {
    const {
        data,
        index,
        style,
    } = props;
    
    return cloneElement(data[index], {
        style: {
            ...style,
            top: (style.top as number) + LISTBOX_PADDING,
        },
    });
}

export const useResetEffect = wrap((ref: RefObject<VariableSizeList>) => {
    if (ref.current != null) {
        ref.current.resetAfterIndex(0, true);
    }
});

export function useResetCache(data: any) {
    const ref = useRef<VariableSizeList>(null);
    
    useEffect(useResetEffect(ref), [data]);
    
    return ref;
}
